import { ILbl    } from "../../../../../src/lbl/ILbl"
import { IPrj } from "../../../../../src/prj/IPrj"
import { IWykrojnikRow } from "../../../../../src/wykrojniki/IWykrojnikRow"
import { ITree } from "../../../../../src/tree/ITree"
import { IOpOperacja, IOpParent } from "./IOp"



export class OpParent implements IOpParent {

    prj_id:any | undefined = undefined
    prj_del:number | undefined = undefined

    lbl_id:any | undefined = undefined
    lbl_del:number | undefined = undefined

    tree_id:any| undefined = undefined
    tree_del:number| undefined = undefined
/*
    prj_idn: string=""
    prj_handlowiec:IFinder=new Finder()
    prj_klient:IFinder=new Finder()
    prj_del:number=0

    tree_grupa_maszyn_arr: string[]=[]
    tree_del:number =0
    tree_date_created: string = ''
    tree_idn: string=""
    tree_nr:number=0
    tree_iml: number=0// ": { $cond: { if: { $gt: [ "$tree.zliczanie_surowcow.iml", 0] }, then: 'IML', else: 'SPL'} },

    wykrojnik_x: number = 0
    wykrojnik_y: number = 0
    wykrojnik_ksztalt: string = ''
    wykrojnik_nr: string = '' //{ $toString:"$wykrojnik.numer" },
    wykrojnik_manualny: number=0
    wykrojnik_szerokosc: number=0

   
    lbl_del: number| undefined = undefined // ": "$lbl.del",
    lbl_nazwa: string = '' // ": {$toString: {$ifNull: [ "$lbl.idn", "" ]}},     
    lbl_preflight_date: string = '' // ": {$toString: {$ifNull: [ "$lbl.preflight_date", "" ]}}, 
    lbl_status: string = '' // ": {$toString: {$ifNull: [ "$lbl.status", "" ]}}, 
    lbl_modified_by: string = '' // ": "$lbl.modified_by", 
    lbl_x: number = 0  // ": "$lbl.x", 
    lbl_y: number = 0  // ": "$lbl.y", 
    lbl_handlowiec: string = '' // ": "$lbl.handlowiec", 
    lbl_klient: string = '' // ": "$lbl.klient", 
    lbl_file_path: string = '' // ": "$lbl.file_path", 
    lbl_original_file_name: string = '' // ": {$toString: {$ifNull: [ "$lbl.original_file_name", "" ]}},  

    lbl_idx_nazwa_etykiety: string = '' // ":{$toString: {$ifNull: [ "$lbl.idx_nazwa_etykiety", "" ]}},  
    lbl_idx_nr_indeksu_erp: string = '' // ":"$lbl.idx_nr_indeksu_erp",
    lbl_idx_nr_indeksu_wzor_erp: string = '' // ":"$lbl.idx_nr_indeksu_wzor_erp",
    lbl_idx_numer_indeksu_u_klienta: string = '' // ":"$lbl.idx_numer_indeksu_u_klienta",


    tree_etap_technologia_technologia_typ :string = '' //":"$tree.etapy.technologie.typ",
    tree_etap_technologia_komponent_id :string = '' //":"$tree.etapy.technologie.komponent_finder._id",
    tree_etap_technologia_komponent_typ :string = '' //":"$tree.etapy.technologie.komponent_typ",
    tree_etap_technologia_komponent_nazwa :string = '' //":"$tree.etapy.technologie.komponent_finder.text",
    tree_etap_etap_typ :string = '' //":"$tree.etapy.etap_typ",
*/

    public init_from_prj(prj: IPrj | undefined) {
        this.prj_id = prj?._id
        /*
        this.prj_idn = prj?.idn ? prj?.idn: ''
        this.prj_handlowiec = prj?.handlowiec ? prj?.handlowiec : new Finder()
        this.prj_klient = prj?.klient ? prj?.klient : new Finder()
        this.prj_del = prj?.del ? prj?.del : 0
        */
    }

    public init_from_tree(tree: ITree | undefined) {
        this.tree_id = tree?._id
        this.lbl_id =  tree?.lbl_id
        /*
        this.tree_grupa_maszyn_arr= tree?.grupa_maszyn_arr ? tree?.grupa_maszyn_arr : []
        this.tree_del= tree?.del ? tree?.del : 0
        this.tree_date_created= tree?.date_created ? tree?.date_created.toString() : ''
        this.tree_idn= tree?.idn ? tree?.idn : ''
        this.tree_nr= (<any>tree).nr ? (<any>tree).nr : 0
        this.tree_iml= (<any>tree).zliczanie_surowcow.iml ? (<any>tree).zliczanie_surowcow.iml : 0
        
        // inicjalizowane z tree
        this.lbl_x = tree?.x ? tree?.x : 0
        this.lbl_y = tree?.y ? tree?.y : 0
        */

    }

    public init_from_wykrojnik(w: IWykrojnikRow | undefined) {
        /*
        this.wykrojnik_x = w?.x ? w?.x : 0
        this.wykrojnik_y = w?.y ? w?.y : 0
        this.wykrojnik_ksztalt = w?.ksztalt ? w?.ksztalt : ''
        this.wykrojnik_nr = w?.numer ? w?.numer.toString() : ''
        this.wykrojnik_manualny = w?.origin=='MAN' ? 1 : 0
        this.wykrojnik_szerokosc = w?.szerokosc ? Number(w.szerokosc) :0
        */
    }

    public init_from_lbl(lbl:ILbl | undefined) {
        this.lbl_id = lbl?._id
/*
        this.lbl_del = lbl?.del
        this.lbl_nazwa = lbl?.idn ? lbl?.idn : '' 
        this.lbl_preflight_date = lbl?.preflight_date ? lbl?.preflight_date.toString() : ''
        this.lbl_status = lbl?.status ? lbl?.status : ''
        this.lbl_modified_by = lbl?.modified_by ? lbl?.modified_by :''
        this.lbl_handlowiec = lbl?.handlowiec ? lbl?.handlowiec : ''
        this.lbl_klient = lbl?.klient ? lbl?.klient :''
        this.lbl_file_path = lbl?.file_path ? lbl?.file_path : ''
        this.lbl_original_file_name = lbl?.original_file_name ? lbl?.original_file_name : ''

        this.lbl_idx_nazwa_etykiety = lbl?.idx_nazwa_etykiety ? lbl?.idx_nazwa_etykiety : ''
        this.lbl_idx_nr_indeksu_erp = lbl?.idx_nr_indeksu_erp ? lbl?.idx_nr_indeksu_erp : ''
        this.lbl_idx_nr_indeksu_wzor_erp = lbl?.idx_nr_indeksu_wzor_erp ? lbl?.idx_nr_indeksu_wzor_erp : ''
        this.lbl_idx_numer_indeksu_u_klienta = lbl?.idx_numer_indeksu_u_klienta ? lbl?.idx_numer_indeksu_u_klienta : ''
    */
    }

    public init_from_operacja(op: IOpOperacja | undefined) {
        /*
        this.ido = op?._id
        this.del = op?.del ? op?.del : 0
        this.tree_etap_technologia_technologia_typ = op?.color ? op?.color.technologia_graflow : ''
        this.tree_etap_technologia_komponent_id = op?.komponent ? op?.komponent._id : ''
        this.tree_etap_technologia_komponent_typ = op?.komponent ? op?.komponent.komponent_typ : ''
        this.tree_etap_technologia_komponent_nazwa = op?.komponent ? op?.komponent.komponent_nazwa : ''
        this.tree_etap_etap_typ = op?.color ? op?.color.etap_graflow : ''
        */
    }
}


